import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { WF } from "../constants/testIds2";
import { Badge } from "../components/ui/badge";
import { UserCircle } from "@phosphor-icons/react";

export default function Bench() {
  const { user, tenantId } = useAuth();
  const [rows, setRows] = useState([]);

  useEffect(() => {
    const params = user?.role === "super_admin" && tenantId ? { tenant_id: tenantId } : {};
    api.get("/bench", { params }).then(({ data }) => setRows(data));
  }, [tenantId, user?.role]);

  return (
    <div className="space-y-6">
      <div>
        <div className="text-xs uppercase tracking-[0.25em] text-orange-500">Bench</div>
        <h1 className="font-display text-4xl md:text-5xl font-bold tracking-tight">Unallocated talent</h1>
        <p className="text-sm text-zinc-500 mt-2">{rows.length} employees ready to be allocated to client projects.</p>
      </div>

      {rows.length === 0 ? (
        <div className="border border-zinc-200 bg-white p-12 text-center text-sm text-zinc-500 rounded-sm">
          Everyone is fully allocated. 🎉
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3" data-testid={WF.benchList}>
          {rows.map((e) => (
            <div key={e.id} className="border border-zinc-200 rounded-sm p-4 bg-white transition-colors duration-150 hover:border-orange-300">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full bg-orange-100 grid place-items-center text-orange-800 font-display font-bold text-sm">
                  {(e.first_name?.[0] || "") + (e.last_name?.[0] || "")}
                </div>
                <div className="flex-1">
                  <div className="text-xs font-mono-plex text-zinc-500">{e.employee_code}</div>
                  <div className="font-display font-bold">{e.first_name} {e.last_name}</div>
                  <div className="text-xs text-zinc-500">{e.designation || "—"} · {e.department || "—"}</div>
                </div>
              </div>
              {e.skill_tags?.length > 0 && (
                <div className="mt-3 flex flex-wrap gap-1.5">
                  {e.skill_tags.map((s) => (
                    <Badge key={s} variant="outline" className="rounded-sm bg-orange-50 border-orange-200 text-orange-800">{s}</Badge>
                  ))}
                </div>
              )}
              <div className="mt-3 pt-3 border-t border-zinc-100 text-[11px] text-zinc-500 flex items-center gap-1">
                <UserCircle size={12} /> Available since {e.date_of_joining || "—"}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
